import { useCallback } from 'react';
import useGlobals from './useGlobals';
import { ModalData } from '../Types';
import { setModal } from '../Store/Actions/modalActions';
import { modelService } from '../Services/modelService';
import { setListReloadType } from '../Store/Actions/environmentActions';
import { PaginationListType } from '../Types/PaginationParams';

const useChatModels = () => {
    const { handleNavigate, userSettings, settings, i18n, dispatch, windowWidth, getBreakpoint } = useGlobals();

    const deleteModelfunction = useCallback(
        (identifier: string) => {
            if (!userSettings.isLoggedIn) return;
            modelService.deleteModel(identifier).then(() => {
                dispatch(setListReloadType(PaginationListType.Models));
            });
        },
        [userSettings.isLoggedIn, dispatch],
    );

    const handleOpenConfirmDialog = useCallback(
        (apiKeyIdentifier: string) => {
            dispatch(
                setModal({
                    state: 'open',
                    title: i18n.translate({ id: 'modelDelete.title', sourceName: 'Models' }),
                    content: i18n.translate({ id: 'modelDelete.text', sourceName: 'Models' }),
                    modalSize: 'small',
                    closeOnAction: true,
                    showCloseButton: false,
                    buttonRightAction: () => deleteModelfunction(apiKeyIdentifier),
                } as ModalData),
            );
        },
        [dispatch, deleteModelfunction, i18n],
    );

    return {
        ModelsActions: {
            handleOpenConfirmDialog,
        },
        handleNavigate,
        i18n,
        settings,
        userSettings,
        windowWidth,
        getBreakpoint,
    };
};

export default useChatModels;
